import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

import { ApiConfig } from '../../shared/config/api.config';
import {
    BusinessService,
    TreeService,
    BreadcrumbService,
} from '../../shared/services';

@Component({
    selector: 'app-gmid-lookup',
    templateUrl: './gmid-lookup.component.html',
    styleUrls: ['./gmid-lookup.component.scss'],
})
export class GmidLookupComponent implements OnInit {
    private readonly GMID_PATTERN = /^[0-9]{10}$/;

    gmidInput: string = '';
    isLoading: boolean = false;
    searchPerformed: boolean = false;

    profitCenter: any = null;
    storeInfo: any = null;
    businessInfo: any = null;
    chainInfo: any = null;

    errorMessage: string = '';

    constructor(
        private router: Router,
        private http: HttpClient,
        private apiConfig: ApiConfig,
        private businessService: BusinessService,
        private treeService: TreeService,
        private breadcrumbService: BreadcrumbService,
    ) {}

    ngOnInit(): void {
        this.setBreadcrumb();
    }

    setBreadcrumb(): void {
        const breadCrumb: any = {};
        breadCrumb.root = 'GMID Lookup';
        breadCrumb.child = '';
        breadCrumb.subChild = '';
        breadCrumb.subChildLink = null;
        breadCrumb.grandChild = '';
        breadCrumb.rootList = [];
        this.breadcrumbService.setBreadCrumb(breadCrumb);
    }

    search(): void {
        const gmid = this.gmidInput.trim();
        if (!gmid) {
            this.errorMessage = 'Please enter a GMID to search.';
            return;
        }
        if (!this.GMID_PATTERN.test(gmid)) {
            this.errorMessage = 'GMID must be exactly 10 digits (numbers only).';
            return;
        }

        this.isLoading = true;
        this.searchPerformed = false;
        this.profitCenter = null;
        this.storeInfo = null;
        this.businessInfo = null;
        this.chainInfo = null;
        this.errorMessage = '';

        const url = `${this.apiConfig.API_HOST}/api/pctr-lookup`;
        this.http.get(url, { params: { xGMID: gmid } }).subscribe(
            (response: any) => {
                this.isLoading = false;
                this.searchPerformed = true;
                if (response?.found && response.data) {
                    const { xbcStore, xbcBusiness, xbcChain, ...pctrFields } = response.data;
                    this.profitCenter = pctrFields;
                    this.storeInfo = xbcStore || null;
                    this.businessInfo = xbcBusiness || null;
                    this.chainInfo = xbcChain || null;
                    if (this.profitCenter.xBusinessID) {
                        this.businessService.setBusinessID(this.profitCenter.xBusinessID);
                        this.treeService.setId(this.profitCenter.xBusinessID, 'business');
                    }
                }
            },
            (error: any) => {
                this.isLoading = false;
                this.searchPerformed = true;
                this.errorMessage = error.status === 403
                    ? 'Invalid request: GMID is required.'
                    : 'Search failed. Please try again.';
            },
        );
    }

    navigateToBusiness(): void {
        if (!this.profitCenter || !this.profitCenter.xBusinessID) return;
        this.businessService.setBusinessID(this.profitCenter.xBusinessID);
        this.treeService.setId(this.profitCenter.xBusinessID, 'business');
        this.router.navigate(['/dashboard/setup/business/structure/information', this.profitCenter.xBusinessID]);
    }

    navigateToStore(): void {
        if (!this.profitCenter || !this.profitCenter.xStoreID) return;
        this.businessService.setBusinessID(this.profitCenter.xBusinessID);
        this.treeService.setId(this.profitCenter.xStoreID, 'store');
        this.router.navigate(['/dashboard/setup/business/structure/store', this.profitCenter.xStoreID]);
    }

    navigateToProfitCenter(): void {
        if (!this.profitCenter || !this.profitCenter._id) return;
        this.businessService.setBusinessID(this.profitCenter.xBusinessID);
        this.treeService.setId(this.profitCenter.xStoreID, 'store');
        this.router.navigate(['/dashboard/setup/business/structure/profit-center', this.profitCenter._id]);
    }
}
